module.exports = __webpack_public_path__ + "ac7fbda6.svg";